export type CampaignStatus =
  | "pending"
  | "processing"
  | "sent"
  | "delivered"
  | "failed"
  | "expired"
  | "unconfirmed"
  | "cancelled"
  | "unknown";
export interface SmsCampaign {
  id: string;
  name: string;
  source: "file" | "reminder";
  created_at: string;
  total: number;
  delivered: number;
  sent: number;
  failed: number;
  pending: number;
  processing: number;
  expired: number;
  unconfirmed: number;
  cancelled: number;
  unknown: number;
  cost: number;
  consumed_count: number;
}
export interface CampaignMessage {
  id: string;
  recipient: string;
  message: string;
  status: CampaignStatus;
  provider_status: string | null;
  provider_message_id: string | null;
  operator: string | null;
  segments: number | null;
  cost: number | null;
  scheduled_at: string | null;
  sent_at: string | null;
  delivered_at: string | null;
  error_message: string | null;
}
export interface CampaignResponse {
  success: boolean;
  campaigns: SmsCampaign[];
  total: number;
  messages: CampaignMessage[];
  provider_available: boolean;
}
